<template>
  <div class="notice" :style="{'paddingTop': statusBar + 'rem'}" ref="getheigh">
    <Header title="解封" :back="true" left="返回" :white="true" />
    <div class="noticemain" ref="getheight">
      <p>{{number}}</p>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "notice",
  /**
   * 初始化数据
   */
  data() {
    return {
      statusBar: 0,
      number: 1,
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);

    console.log(window.scrollY);
  },
  updated() {
    /**
     * 页面加载完毕后Y轴置在最顶端
     * bug出现形式未知
     */
    window.scroll(0, 0);
    console.log("nextTick " + window.scrollY);
  },

  /**
   * 方法
   */
  methods: {},
  created() {
    // setInterval(() => {
    //   this.number++;
    // }, 1000);
  },
  watch: {
    number(n, o) {
      console.log(n);
    },
  },

  components: {
    Header,
  },
};
</script>

<style scoped lang="scss">
.notice {
  //width: 100%;
  background: #f7f8fa;
  .noticemain {
    overflow: auto;
    background: #fff;
    .kefu {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>